import { render, staticRenderFns } from "./catering-form.vue?vue&type=template&id=e6778902&scoped=true&"
import script from "./catering-form.vue?vue&type=script&lang=js&"
export * from "./catering-form.vue?vue&type=script&lang=js&"
import style0 from "./catering-form.vue?vue&type=style&index=0&id=e6778902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6778902",
  null
  
)

export default component.exports